import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-6 pb-2 px-3 md:pt-12 md:pb-4" data-id="element-162">
      <div className="max-w-xl mx-auto text-center" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-164">
          {/* Small badge */}
          <div className="inline-block bg-amber-500/20 text-brand-yellow px-4 py-1.5 rounded-full text-xs font-bold mb-4 border border-amber-500/30 tracking-wide" data-id="element-165">
            👩‍🏫 SISTEMA COMPLETO PARA MAESTRAS DE INICIAL, KINDER O JARDÍN
          </div>

          {/* Main headline - larger and bolder */}
          <h1 className="text-[2rem] md:text-5xl lg:text-6xl font-extrabold leading-[1.1] mb-3 px-0" data-id="element-166">
            👉 Todo tu año de Clases de Inicial{' '}
            <span className="bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent" data-id="element-167">
              resuelto...
            </span>
          </h1>

          {/* Subtitle - italic, lighter */}
          <p className="text-base md:text-xl text-gray-400 italic mb-4 max-w-md mx-auto leading-relaxed" data-id="element-168">
            Un sistema claro para enseñar sin improvisar, sin gritar y con más
            tranquilidad
          </p>

          {/* Product image */}
          <div className="w-full mb-5 px-2" data-id="element-169">
            <img src="https://cdn.magicpatterns.com/uploads/7EP2fDLDL8ZnaBcRx1B64M/MOCKUP_600X600.png" alt="Megapack Inicial Sin Estrés" className="w-full h-auto drop-shadow-2xl cursor-pointer" onClick={() => document.getElementById('oferta')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-170" />
          </div>

          {/* Yellow highlight text */}
          <p className="text-brand-yellow text-base md:text-lg font-medium italic mb-3 max-w-sm mx-auto leading-snug" data-id="element-171">
            Listo para usar. Sin improvisar. Sin gritar. Sin llegar agotada al
            aula.
          </p>

          {/* Gray description */}
          <p className="text-sm md:text-base text-gray-400 italic mb-8 max-w-sm mx-auto leading-relaxed" data-id="element-172">
            El sistema para maestras de educación inicial (
            <span className="text-amber-400 font-semibold not-italic" data-id="element-173">
              kínder, jardín, preescolar
            </span>
            ): clases completas, actividades listas y control del aula sin
            estrés.
          </p>

          {/* Full-width CTA */}
          <CTAButton text="👉 QUIERO MI MEGAPACK AHORA" className="w-auto mx-auto mb-5 py-3 px-6 text-sm md:text-base font-black rounded-xl" data-id="element-174" />

          {/* Trust badges - compact row */}
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[11px] md:text-xs text-gray-500" data-id="element-175">
            <div className="flex items-center gap-1" data-id="element-176">
              <ShieldCheck size={14} className="text-brand-yellow" data-id="element-177" />
              <span data-id="element-178">Garantía 7 días sin preguntas</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-179">
              <Lock size={14} className="text-brand-yellow" data-id="element-180" />
              <span data-id="element-181">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-182">
              <CreditCard size={14} className="text-brand-yellow" data-id="element-183" />
              <span data-id="element-184">Pagas en la moneda de tu país</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}